import { Link } from "react-router-dom";

export function LegalFooter({ className = "" }) {
  return (
    <footer data-testid="legal-footer" className={`text-center text-xs text-slate-400 leading-relaxed ${className}`}>
      <div className="font-semibold text-slate-500">Molaroo<span className="align-super text-[9px]">™</span></div>
      <div>A NavScora product</div>
      <div className="mt-1 flex items-center justify-center gap-2 flex-wrap">
        <Link to="/terms" data-testid="footer-terms" className="text-[#0D786A] df-pressable">Terms &amp; Conditions</Link>
        <span aria-hidden>·</span>
        <Link to="/privacy" data-testid="footer-privacy" className="text-[#0D786A] df-pressable">Privacy Policy</Link>
        <span aria-hidden>·</span>
        <a href="mailto:privacy@navscora.com" data-testid="footer-contact" className="text-[#0D786A] df-pressable">Contact / Support</a>
      </div>
      <div className="mt-1">© NavScora Pty Ltd</div>
    </footer>
  );
}
